import React, { useState, useEffect } from 'react'
import { Row, Col, Form, Button, Table } from 'react-bootstrap'
import Card from '../../../components/Card'
import ToastNotification from '../../../components/Toast';
import { toast } from 'react-toastify';
import { API_CALL_CENTRE_CREATE, API_COUNTRY_CODES_LIST, API_TIMEZONES_LIST, API_PARENT_CALL_CENTER_LICENCE } from '../../../service/url';
import { postApiCall, getApiCall, fetchAndSetFlashMessage} from '../../../service/httpCall';
import { useNavigate } from 'react-router-dom';
import { ROUTES, USER_ROLES, MODULE_ACL, FLASH_MESSAGE_ACTION_OBJECT   } from '../../../utilities/constant';
// import { getApiCall } from '../../../service/httpCall';
import { useAuth, errorCheck } from '../auth/auth-utils';

import { Storage } from "../../../utilities/setting";

const CallCentreCreate = () => {
   const { checkAuth } = useAuth();
   const navigate = useNavigate();

   const [name, setName] = useState('');
   const [domain, setDomain] = useState('');
   const [description, setDescription] = useState('');
   const [showToast, setShowToast] = useState(false);
   const [toastProps, setToastProps] = useState(null);
   const [buttonDisable, setButtonDisable] = useState(false);
   const [countryCodeList, setCountryCodeList] = useState([]);
   const [countryCode, setCountryCode] = useState('');
   const [timezonesList, setTimezonesList] = useState([]);
   const [timezone, setTimezone] = useState('');
   const [filteredTimezones, setFilteredTimezones] = useState([]);
   const [licence, setLicence] = useState('');
   const [parentLicence, setParentLicence] = useState(null);
   const [callCenterAdminTeamlead, setCallCenterAdminTeamlead] = useState(0);
   const [agent, setAgent] = useState(0);
   const [liveAgent, setLiveAgent] = useState(0);
   const [channel, setChannel] = useState(0);
   const [errors, setErrors] = useState({});
   const [availableLicence, setAvailableLicence] = useState({});
   const [asReseller, setAsReseller] = useState(0);
   const [asCompany, setAsCompany] = useState(0);
   const [loginUserRole, setLoginUserRole] = useState(null);
   const [nameError, setNameError] = useState('');
   const [domainError, setDomainError] = useState(''); 
   const [notes, setNotes] = useState([]);

   useEffect(() => {
      getUser();
   }, [])

   useEffect(() => {
    getApiCall(API_PARENT_CALL_CENTER_LICENCE).then((resp) => {
      setParentLicence(resp?.parentLicence);
    }).catch((error) => {
      toast.warning(JSON.stringify(error))
    });

    fetchAndSetFlashMessage(
      msg => msg.module_name === MODULE_ACL.CALL_CENTRE && msg.action === FLASH_MESSAGE_ACTION_OBJECT.ADD && msg.type === 'Note',
      setNotes
    );
   }, []);

const validateInput = (value, key) => {
  const num = Number(value);
  let newErrors = { ...errors };

  if (Number.isNaN(num)) return 0;
  if (num < 0) {
    newErrors[key] = "Value cannot be negative";
    setErrors(newErrors);
    return 0;
  }

  const licenceKeyMap = {
   //  role_ccadmin: "role_ccadmin",
    agent: "role_ccagent",
    live_agent: "live_agent",
    channel: "channel",
    reseller: "reseller",
    company: "company",
  };

  const licenceKey = licenceKeyMap[key];
  const availableValue = parentLicence?.available_licence?.[licenceKey];

  if (availableValue === 0 && num > 0) {
    newErrors[key] = "Value cannot be more than 0";
    setErrors(newErrors);
    return num;
  }

  newErrors[key] = "";

  const nextAgent = key === "agent" ? num : agent;
  const nextLiveAgent = key === "live_agent" ? num : liveAgent;

  if (nextAgent < nextLiveAgent) {
    newErrors.agent = "Total Agent cannot be less than Live Agent";
    newErrors.live_agent = "Live Agent cannot be more than Total Agent";
  } else {
    newErrors.agent = "";
    newErrors.live_agent = "";
  }

  if (
    availableValue !== null &&
    availableValue !== undefined &&
    availableValue > 0
  ) {
   //  if (
   //    key === "role_ccadmin" &&
   //    num > availableValue - 1
   //  ) {
   //    newErrors.role_ccadmin = `Value cannot be more than ${availableValue - 1}`;
   //  }

    if (
      key !== "role_ccadmin" &&
      num > availableValue
    ) {
      newErrors[key] = `Value cannot be more than ${availableValue}`;
    }
  }

  if (key === "live_agent" && num > nextAgent) {
    newErrors.live_agent = `Live Agent cannot be more than Total Agent (${nextAgent})`;
  }

  setErrors(newErrors);
  return num;
};


async function getUser(){
  try {
   const user = JSON.parse(Storage.getItem('user'));
   if (user) {
     setLoginUserRole(user.role);
   }
  } catch(err){
    console.log(err)
  }
}

   useEffect( () => {

      getApiCall(API_COUNTRY_CODES_LIST, {})
         .then(onCountryCodeListSuccess)
         .catch(onError);

      getApiCall(API_TIMEZONES_LIST, {})
         .then(onTimezonesListSuccess)
         .catch(onError);         

   }, []);

   useEffect(() => {
      checkAuth(setToastProps, setShowToast)
    }, []);

   // useEffect(() => {

   //    if (toastProps) {
   //       setShowToast(true);
   //    }

   // }, [toastProps]);

   function onCountryCodeListSuccess(resp) {
      setCountryCodeList(resp);
   }


   function onTimezonesListSuccess(resp){
      setTimezonesList(resp);
   }


   function onError(err) {
      if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
         errorCheck(err, navigate, setToastProps, setShowToast)
      } else {
        console.log(err)
      }
   }

   const validateName = (value) => {
      const trimmedValue = value.trim();
      if (!trimmedValue) {
         setNameError("Name is required");
         return false;
      }
      if (trimmedValue.length < 3) {
         setNameError("Name must be at least 3 characters long");
         return false;
      }
      if (trimmedValue.length > 500) {
         setNameError("Name must not exceed 500 characters");
         return false;
      }
      // Allow only letters, numbers, and underscores
      const nameRegex = /^[a-zA-Z0-9_]+$/;
      if (!nameRegex.test(trimmedValue)) {
         setNameError("Name can only contain letters, numbers, and underscores (_). No special characters allowed.");
         return false;
      }
      setNameError("");
      return true;
   };

   const validateDomain = (value) => {
   const trimmedValue = value.trim();

   if (!trimmedValue) {
      setDomainError("Domain is required");
      return false;
   }

   if (trimmedValue.length > 500) {
      setDomainError("Domain must not exceed 500 characters");
      return false;
   }

   // Allow only http or https URLs
   const urlRegex = /^https?:\/\/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/;

   if (!urlRegex.test(trimmedValue)) {
      setDomainError("Please enter a valid URL (e.g., https://example.com or http://example.com)");
      return false;
   }

   setDomainError("");
   return true;
   };

   function validateForm() {

      let valid = true;
      let errorMessage = '';

      // Validate name and domain first
      const nameValid = validateName(name);
      const domainValid = validateDomain(domain);

      if (!nameValid) {
         valid = false;
         errorMessage = nameError || "Name validation failed";
      }
      if (!domainValid) {
         valid = false;
         if (errorMessage) {
            errorMessage += "; " + (domainError || "Domain validation failed");
         } else {
            errorMessage = domainError || "Domain validation failed";
         }
      }
      if (!description.trim()) {
         valid = false;
         if (errorMessage) {
            errorMessage += "; Description required";
         } else {
            errorMessage = "Description required";
         }
      }
      if (!countryCode.trim()) {
         valid = false;
         if (errorMessage) {
            errorMessage += "; Country Code required";
         } else {
            errorMessage = "Country Code required";
         }
      }
      if (!timezone.trim()) {
         valid = false;
         if (errorMessage) {
            errorMessage += "; Timezone required";
         } else {
            errorMessage = "Timezone required";
         }
      }

      if (!valid && errorMessage) {
         toast.warning(errorMessage);
      }

      return valid;

   }

   async function submitForm() {

      setButtonDisable(true);

      if (!validateForm()) {
         setButtonDisable(false);
         return;
      }
      //  if (liveAgent > 10) {
      //       toast.warning("Live Agent cannot exceed 10")
      //       setButtonDisable(false);
      //       return;
      //    }

      const params = {
          name,
          domain, 
          description, 
          countryCode,
          timezone,
          licence: {
            // role_ccadmin: callCenterAdminTeamlead,
            role_ccagent: agent,
            live_agent: liveAgent,
            channel: channel,
            reseller: asReseller,
            company: asCompany,
         } 
      }

      postApiCall(API_CALL_CENTRE_CREATE, params)
         .then(onCreateCreateSuccess)
         .catch(onCreateCreateError);

   }

   function onCreateCreateSuccess(resp) {
      toast.success("Call Centre created successfully")
      setTimeout(() => {
         navigate(`/${ROUTES.CALL_CENTRES.LIST}`);
      }, 1500);
   }

   function onCreateCreateError(err) {
      if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
         errorCheck(err, navigate, setToastProps, setShowToast)
      } else {
        setButtonDisable(false);
        toast.warning(JSON.stringify(err))
      }
   }

   const handleCountryChange = (e) => {
    const selectedCountryId = e.target.value;
    setCountryCode(selectedCountryId);

    const selectedCountry = countryCodeList.find(c => c.id === selectedCountryId);
    if (selectedCountry) {
        const filtered = timezonesList.filter(tz => tz.value.toLowerCase().includes(selectedCountry.name.toLowerCase()));
        setFilteredTimezones(filtered);
    } else {
        setFilteredTimezones([]);
    }
};


   return (
      <>
         <div>
            <Row>
               <Col xl="12" lg="12">
                  <Card>
                     <Card.Header className="d-flex justify-content-between">
                        <div className="header-title">
                           <h4 className="card-title">New Call Centre Information</h4>
                        </div>
                     </Card.Header>
                     <Card.Body>
                        <div className="new-user-info">
                           <form>
                              <div className="row">
                                 <Form.Group className="col-md-6 form-group">
                                    <Form.Label htmlFor="name">Name: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                                    <Form.Control 
                                       type="text" 
                                       id="name" 
                                       maxLength={500} 
                                       value={name} 
                                       onChange={e => {
                                          setName(e.target.value);
                                          validateName(e.target.value);
                                       }}
                                       onBlur={e => validateName(e.target.value)}
                                       isInvalid={!!nameError}
                                       required 
                                    />
                                    {nameError && <Form.Control.Feedback type="invalid">{nameError}</Form.Control.Feedback>}
                                 </Form.Group>
                                 <Form.Group className="col-md-6 form-group">
                                    <Form.Label htmlFor="domain">Domain: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                                    <Form.Control 
                                       type="text" 
                                       id="domain" 
                                       maxLength={500} 
                                       value={domain} 
                                       onChange={e => {
                                          setDomain(e.target.value);
                                          validateDomain(e.target.value);
                                       }}
                                       onBlur={e => validateDomain(e.target.value)}
                                       isInvalid={!!domainError}
                                       required 
                                    />
                                    {domainError && <Form.Control.Feedback type="invalid">{domainError}</Form.Control.Feedback>}
                                 </Form.Group>
                              </div>
                              <div className="row">
                                 <Form.Group className="col-md-6 form-group">
                                    <Form.Label htmlFor="countryCode">Select Country Code: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                                    <Form.Select id="countryCode" required value={countryCode} onChange={handleCountryChange}>
                                       <option value={''}>Select</option>
                                       {
                                          countryCodeList.map(function (val, idx) {
                                             return (<option key={idx} value={val.id}>{val.name}</option>)
                                          })
                                       }
                                    </Form.Select>
                                 </Form.Group>

                                  <Form.Group className="col-md-6 form-group">
                                    <Form.Label htmlFor="timezone">Select Timezone: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                                    <Form.Select id="timezone" required value={timezone} onChange={e => setTimezone(e.target.value)}>
                                       <option value={''}>Select</option>
                                       {
                                          filteredTimezones.map(function (val, idx) {
                                             return (<option key={idx} value={val.id}>{val.value}</option>)
                                          })
                                       }
                                    </Form.Select>   
                                 </Form.Group>
                                 {/* // */}
                              </div>
                              <div className="row">
                                 <Form.Group className="col-md-6 form-group">
                                    <Form.Label htmlFor="description">Description: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                                    <Form.Control as="textarea" rows={3} id="description" maxLength={500} value={description} onChange={e => setDescription(e.target.value)} required />
                                 </Form.Group>
                              </div>
                              <hr />
                              <div className="scroll-container" style={{marginBottom:"30px"}}>
                                <div style={{ display: "flex", justifyContent: "space-between",alignItems: "center", gap: "12px", marginBottom: "20px" }}>
                                  <h5 style={{ margin: 0 }}>Licence</h5>
                                    <div
                                      style={{
                                        background: "#FFF8C6",
                                        color: "#8B5A2B",
                                        padding: "8px 12px",
                                        borderRadius: "6px",
                                        display: "flex",
                                        alignItems: "center",
                                        fontSize: "14px",
                                        fontWeight: 500,
                                      }}
                                    >
                                      <span>
                                        {/* <strong>Note:</strong> One <strong>Call Centers Licence </strong>is automatically used for the newly created Callcentre. */}
                                        <strong>Note: </strong>{notes.find(n => Number(n.priority) === 1)?.message ?? ""}
                                      </span>
                                    </div>
                                </div>
                                <Table striped bordered hover responsive style={{ minWidth: "1000px", textAlign: "center"}}>
                                  <thead>
                                    <tr>
                                      {/* <th style={{ width: "15%" }}>Call Centers</th> */}
                                      <th style={{ width: "15%" }}>Total Agent</th>
                                      <th style={{ width: "15%" }}>Live Agent</th>
                                      <th style={{ width: "15%" }}>Channels</th>
                                      {/* {loginUserRole !== USER_ROLES.COMPANY_ADMIN && <th style={{ width: "15%" }}>Reseller</th>} */}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      {/* <td>
                                        <Form.Group className="form-group">
                                          <Form.Control
                                            type="number"
                                            placeholder="Teamlead"
                                            min={0}
                                            value={String(parseInt(String(callCenterAdminTeamlead), 10))}
                                            onChange={(e) => setCallCenterAdminTeamlead(validateInput(e.target.value, "role_ccadmin"))}
                                            required
                                          />
                                          {errors.role_ccadmin && <small className="text-danger">{errors.role_ccadmin}</small>}
                                        </Form.Group>
                                      </td> */}

                                      <td>
                                        <Form.Group className="form-group">
                                          <Form.Control
                                            type="number"
                                            placeholder="Agent"
                                            min={0}
                                            value={String(parseInt(String(agent), 10))}
                                            onChange={(e) => setAgent(validateInput(e.target.value, "agent"))}
                                            required
                                          />
                                          {errors.agent && <small className="text-danger">{errors.agent}</small>}
                                        </Form.Group>
                                      </td>

                                      <td>
                                        <Form.Group className="form-group">
                                          <Form.Control
                                            type="number"
                                            placeholder="Live Agent"
                                            min={0}
                                          //   max={10}   
                                            value={String(parseInt(String(liveAgent), 10))}
                                            onChange={(e) => setLiveAgent(validateInput(e.target.value, "live_agent"))}
                                            required
                                          />
                                          {errors.live_agent && <small className="text-danger">{errors.live_agent}</small>}
                                        </Form.Group>
                                      </td>

                                      <td>
                                        <Form.Group className="form-group">
                                          <Form.Control
                                            type="number"
                                            placeholder="Channel"
                                            min={0}
                                            value={String(parseInt(String(channel), 10))}
                                            onChange={(e) => setChannel(validateInput(e.target.value, "channel"))}
                                            required
                                          />
                                          {errors.channel && <small className="text-danger">{errors.channel}</small>}
                                        </Form.Group>
                                      </td>

                                      {/* {loginUserRole !== USER_ROLES.COMPANY_ADMIN &&
                                      <td>
                                        <Form.Group className="form-group">
                                          <Form.Control
                                            type="number"
                                            placeholder="As Reseller"
                                            min={0}
                                            value={String(parseInt(String(asReseller), 10))}
                                            onChange={(e) => setAsReseller(validateInput(e.target.value, "reseller"))}
                                            required
                                          />
                                          {errors.reseller && <small className="text-danger">{errors.reseller}</small>}
                                        </Form.Group>
                                      </td>} */}
                                    </tr>
                                  </tbody>
                                </Table>
                              </div>

                              {loginUserRole !== USER_ROLES.SUPERADMIN &&
                              <div 
                                style={{
                                  background: "#FFF8C6",
                                  color: "#8B5A2B",
                                  padding: "10px 15px",
                                  borderRadius: "6px",
                                  marginBottom: "15px",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  fontSize: "14px",
                                  fontWeight: 500,
                                  marginTop:"70px",
                                  marginBottom:"20px"
                                }}
                              >
                                {/* <span><strong>Note:</strong> This licence detail is informational purpose and cannot be edited.</span> */}
                                <strong>Note: </strong>{notes.find(n => Number(n.priority) === 2)?.message ?? ""}
                              </div>}
                              
                              {loginUserRole !== USER_ROLES.SUPERADMIN &&
                              <div className="scroll-container" style={{ marginBottom: "30px" }}>
                                <h5 style={{ marginBottom: "10px" }}>Available Licence (Allocated Company)</h5>
                                <Table striped bordered hover responsive style={{ minWidth: "1000px", textAlign: "center" }}>
                                  <thead>
                                    <tr>
                                      <th>Call Centers</th>
                                      <th>Total Agent</th>
                                      <th>Live Agent</th>
                                      <th>Channels</th>
                                      {/* {loginUserRole !== USER_ROLES.COMPANY_ADMIN && <th>Reseller</th>} */}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>{parentLicence?.available_licence?.role_ccadmin || 0}</td>
                                      <td>{parentLicence?.available_licence?.role_ccagent || 0}</td>
                                      <td>{parentLicence?.available_licence?.live_agent || 0}</td>
                                      <td>{parentLicence?.available_licence?.channel || 0}</td>
                                      {/* {loginUserRole !== USER_ROLES.COMPANY_ADMIN && 
                                        <td>{parentLicence?.available_licence?.reseller || 0}</td>} */}
                                    </tr>
                                  </tbody>
                                </Table>
                              </div>}

                                                            {/* // */}
                              <Button 
                                onClick={submitForm} 
                                type="button" 
                                variant="btn btn-primary" 
                                disabled={buttonDisable || Object.values(errors).some(error => error !== "") || !!nameError || !!domainError}
                              >
                                Create New Call Centre &nbsp;
                                {
                                  buttonDisable ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : <></>
                                }
                              </Button>

                           </form>
                        </div>
                     </Card.Body>
                  </Card>
               </Col>
            </Row>
         </div>

         {/* <ToastNotification show_toast={showToast} set_show_toast={setShowToast} {...toastProps} /> */}

      </>
   )

}

export default CallCentreCreate;